const navitems = document.querySelectorAll('.nav-item.has-sub')
navitems.forEach(navitem => {
  let trigger = navitem.querySelector('.nav-item-trigger')

  trigger.addEventListener('click',function() {
    navitem.classList.toggle('is-open')
  })
})

const searchTrigger = document.getElementById('search-trigger')
const navtoggler = document.getElementById('navbar-toggler')
if (navtoggler != null) {
  navtoggler.addEventListener('click', function () {
    searchTrigger.classList.toggle('disabled')
  })
}
